import { getFirstLastInitials } from "~vue/utils/stringUtils";

export function getAvatarInitials(name: string | null | undefined): string {
    const normalized = (name ?? "").trim().replace(/\s+/g, " ");
    return normalized ? getFirstLastInitials(normalized) : "";
}
